// extracted by mini-css-extract-plugin
module.exports = {"copyable-link":"copyable-link__copyable-link___h9_VG"};